<template>
  <v-container>
    <v-layout>
    <v-flex>
       <v-tooltip top >
      <v-btn
          class="mr-2 mb-2"
          @click="newCompany"
          color="customPurple"
          dark
          fixed
          bottom
          right
          fab
          slot="activator"
        >
          <v-icon>add</v-icon>
        </v-btn>
        <span>Crear Cliente</span>
    </v-tooltip>
      <div>
        <v-layout>
          <v-flex xs12 sm6 offset-sm6>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
      <v-dialog
        v-model="dialog"
        max-width="500px"
        transition="dialog-bottom-transition"
        scrollable>
        <v-card tile>
          <v-toolbar card dark color="nav_background_color">
            <v-btn icon dark @click.native="dialog = false" @click="cleanData">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Crear nuevo Cliente</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout>
              <v-flex xs12 sm7 offset-sm1>
                <v-text-field
                  name="codigo"
                  label="Cédula/RUC"
                  id="code"
                  :rules="codeRules"
                  :counter="13"
                  required
                  v-model="company.code"
                  @blur="validarCedulaRuc"
                ></v-text-field>
              </v-flex>
            </v-layout>
              <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                  <v-text-field
                    name="nombre"
                    label="Nombre"
                    id="nombre"
                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 50) || 'El número de caracteres debe ser menor a 50']"
                    v-model="company.name"
                    required
                    v-on:keyup.enter="saveData"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                  <v-switch
                    label="Inactivo / Activo"
                    v-model="company.status"
                  ></v-switch>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 sm6 offset-sm4>
                  <div>
                    <v-btn class="btn-rounded" :disabled="!valid"
                           @click="saveData"  large color="primary">Guardar</v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <div style="flex: 1 1 auto;"></div>
        </v-card>
      </v-dialog>
    </v-layout>
       <h3 class="primary--text">Lista de Clientes</h3>
      <v-data-table
        :headers="headers"
        :items="$store.state.companies"
        class="elevation-1"
        sort-icon="mdi-menu-down"
        :search="search"
      >
        <template slot="items" slot-scope="props">         
          <td class="text-xs-left">{{ props.item.code }}</td>
          <td class="text-xs-left">{{ props.item.name }}</td>          
          <td class="text-xs-left">{{ props.item.status?"Activo":"Inactivo" }}</td>
          <td>
            <v-tooltip top >
               <v-btn 
               fab dark 
               small @click="editItem(props.item)" 
               slot="activator"
               color="primary">
                <v-icon dark>edit</v-icon>
              </v-btn>
              <span>Editar</span>
              </v-tooltip>
              <v-tooltip top >
                <v-btn fab dark small @click="deleteItem(props.item)" slot="activator" color="primary">
                  <v-icon dark>delete</v-icon>
                </v-btn>
              <span>Eliminar</span>
              </v-tooltip>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
           No se han encontrado resultados para "{{ search }}".
        </v-alert>
      </v-data-table>
  </v-container>
</template>
<script>

  import Company from "../../model/Company";

  export default {
    data () {
      return {
        search: '',
        valid: false,
        codeRules: [
          v => !!v || 'El código es requerido',
          v => (v && v.length <= 13) || 'El código debe tener 10 o 13 caracteres'
        ],
        requiredField:[v => !!v || 'Es requerido'],
        dialog: false,
        headers: [
          { text: 'Cédula/RUC', value: 'code' },
          { text: 'Nombre', value: 'name' },          
          { text: 'Estado', value: 'estado' },
          { text: 'Acciones', value: 'editar' },

        ],
        editedIndex: -1,
        company: new Company()
      };
    },methods:{
      cleanData(){
        this.valid = false
        this.dialog= false
        this.$refs.form.reset()
        this.company= new Company()
      },
      newCompany(){
        this.editedIndex = -1
        this.dialog= true
        this.valid = false
        this.$refs.form.reset()
        this.company = new Company()
      },
      saveData(){       
        if (this.validarCedulaRuc()) {         
          if(this.$refs.form.validate()){
            if (this.editedIndex > -1) {
              this.$store.dispatch('updateCompany',this.company).then(response => {
                this.cleanData()
              }, error => {
                this.$store.state.progress = false
                this.$store.state.dialogError = true
              })
            } else {
              this.$store.dispatch('addCompany',this.company).then(response => {
                this.cleanData()
              }, error => {
                this.$store.state.progress = false
                this.$store.state.dialogError = true
              })
            }
            this.dialog = false
          }
        }
      },
      editItem (item) {
        this.editedIndex = this.$store.state.companies.indexOf(item)
        this.company = Object.assign({}, item)
        this.dialog = true
      },
      deleteItem (item) {
        this.editedIndex = this.$store.state.companies.indexOf(item)
        this.company = Object.assign({}, item)
        confirm('Está seguro de que quiere eliminar el registro?') && this.$store.dispatch('deleteCompany',this.company.id)
      },
      validarCedulaRuc() {
          let cad = this.company.code;
          let total = 0;
          let longitud = cad.length;
          let longcheck = longitud - 1;

          if (cad !== "" && longitud === 10){
              for(let i = 0; i < longcheck; i++){
                  if (i%2 === 0) {
                      let aux = cad.charAt(i) * 2;
                      if (aux > 9) aux -= 9;
                      total += aux;
                  } else {
                      total += parseInt(cad.charAt(i)); // parseInt o concatenará en lugar de sumar
                  }
              }

              total = total % 10 ? 10 - total % 10 : 0;

              if (cad.charAt(longitud-1) != total) {
                  this.$store.state.dialogErrorMessage = "Cédula inválida";
                  this.$store.state.dialogError = true
                  return false;
              }

              return true;
          }

          if (cad !== "" && longitud !== 10 && longitud !== 13) {
              this.$store.state.dialogErrorMessage = "Debe ingresar una cédula o RUC válido.";
              this.$store.state.dialogError = true
              return false;
          }

          return true;
      }
    },
      computed : {
      },
      beforeCreate(){
        this.$store.dispatch('getCompanies').then(response => {
          this.cleanData()
        }, error => {
          this.$store.state.dialogError = true
        })
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/company/Company.vue